import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=ab3e4964&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=ab3e4964&prod&lang=less&scoped=true"
import style1 from "./forgetPassword.vue?vue&type=style&index=1&id=ab3e4964&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3e4964",
  null
  
)

export default component.exports